import { Box, Text } from 'grommet';
import { WidthType } from 'grommet/utils';
import React from 'react';

import { NetCostComparisonRow } from '@/features/bid-analysis/types/net-cost-comparison';
import { formatNumber } from '@/utils/formatting';

type NumericCellProps = {
  row: NetCostComparisonRow;
  value: number;
  minimumFractionDigits: number;
  maximumFractionDigits: number;
  isSuppressable?: boolean;
  isSuppressed?: boolean;
  singleState?: boolean;
  showTotal?: boolean;
  width?: WidthType;
};

export const NumericCell = (props: NumericCellProps) => {
  const {
    row,
    value,
    minimumFractionDigits,
    maximumFractionDigits,
    isSuppressable,
    isSuppressed,
    singleState,
    showTotal,
    width
  } = props;

  let renderedValue;
  if (isSuppressed && isSuppressable) {
    renderedValue = 'Suppressed';
  } else {
    renderedValue = renderOptionalNumber(value, minimumFractionDigits, maximumFractionDigits);
  }

  const jsxMap = {
    tag: <Text>{renderedValue}</Text>,
    ndc: <Text>{renderedValue}</Text>,
    drug: <Text>{renderedValue}</Text>,
    state: <></>,
    'state-total': showTotal && (singleState ? <Text weight="bold">{renderedValue}</Text> : <Text>{renderedValue}</Text>),
    'drug-total': showTotal && <Text weight="bold">{renderedValue}</Text>,
    'grand-total': showTotal && <Text weight="bold">{renderedValue}</Text>,
  };

  return (
    <Box width={width}>
      {jsxMap[row.rowType]}
    </Box>
  );
};

const renderOptionalNumber = (value?: number, minimumFractionDigits?: number, maximumFractionDigits?: number) => {
  if (value != null) {
    return formatNumber(value, minimumFractionDigits, maximumFractionDigits);
  }

  return <>&mdash;</>;
};
